const AppPromoSection = ({
  titleHighlight,
  title,
  subtitle,
  featuresLeft = [],
  featuresRight = [],
//   images = [],
  mobileImg,
  ctaText,
  onCtaClick,
}) => {
  return (
    <section className="test-section py-5 text-white">
      <div className="custom-container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="FS40FW600 top-section-text">
            <span className="text-success">{titleHighlight} </span>
            {title}
          </h2>
          <p className="mt-3 text-light opacity-75 FS16FW500 fw-400 plus-sans">{subtitle}</p>
        </div>

        {/* Content */}
        <div className="row align-items-stretch pt-4">
          {/* Left Features */}
          <div className="col-lg-4 mb-4 mb-lg-0 d-flex flex-column justify-content-between">
            {featuresLeft.map((item, index) => (
              <FeatureItem key={index} item={item} align="end" />
            ))}
          </div>

          {/* Center Images */}
          <div className="col-lg-4 text-center mb-4 mb-lg-0">
            <div className="position-relative d-inline-block">
                <img
                  src={mobileImg}
                  alt="app"
                  className={`img-fluid app-img`}
                  />
            </div>
          </div>
        {/* {images.map((img, index) => ())} img-${index}*/}

          {/* Right Features */}
          <div className="col-lg-4 mb-5 d-flex flex-column justify-content-between">
            {featuresRight.map((item, index) => (
              <FeatureItem key={index} item={item} align="end" />
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-5">
          <button className="primary-btn" onClick={onCtaClick}>
            {ctaText}{" "}<img src={`/images/web-new-images/right-arrow.svg`} alt="Register Now" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default AppPromoSection;

const FeatureItem = ({ item, align }) => {
  return (
    <div className={`d-flex mb-4 text-start`}>
      {align === "end" && (
        <div className="me-3">
          <div className="icon-box">
            {/* <i className={item.icon}></i> */}
            <img src={item.icon} alt="Idea icon image" />
          </div>
        </div>
      )}

      <div>
        <h6 className="plus-sans FS20FW500 fw-700 to-unset-transform">{item.title}</h6>
        <p className="text-light opacity-75 mb-0 FS16FW500 plus-sans">{item.description}</p>
      </div>

      {/* {align === "start" && (
        <div className="ms-3">
          <div className="icon-box">
            <img src={item.icon} alt="Idea icon image" />
          </div>
        </div>
      )} */}
    </div>
  );
};
